<template>
  <div v-if="clientPortal != null" id="list-client-portal-translation">
    <v-row v-if="languages != null && languages.length > 0">
      <v-col cols="12">
        <v-card :loading="isLoading">
          <v-card-title>
            <v-text-field
              v-model="searchTerm"
              label="Recherche par mot clé"
              hint="Traduction ou clés de traduction"
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-tooltip bottom v-if="clientPortal.firstNas">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  text
                  icon
                  v-on="on"
                  v-bind="attrs"
                  :href="
                    baseUrl +
                    'login-url.php?id=' +
                    clientPortal.firstNas.nasIdentifier +
                    '&translation=key'
                  "
                  target="_blank"
                >
                  <v-icon>mdi-translate</v-icon>
                </v-btn>
              </template>
              <span>Ouvrir les clés de traduction</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :disabled="!isGrantedUser()"
                  small
                  @click="openConfirmDialog = true"
                  v-on="on"
                  v-bind="attrs"
                  icon
                  :loading="loadingReset"
                >
                  <v-icon>mdi-restart</v-icon>
                </v-btn>
              </template>
              <span>Reset de la surcharge</span>
            </v-tooltip>
          </v-card-title>
          <v-card-text>
            <v-tabs v-if="!isLoading">
              <v-tab
                v-for="lang in languages"
                :key="lang"
                :href="`#tab-${lang}`"
              >
                {{ lang }}
              </v-tab>

              <v-tab-item
                v-for="lang in languages"
                :key="lang"
                :value="'tab-' + lang"
                class="px-2"
                style="background-color: white"
              >
                <div
                  v-if="
                    clientPortal.portalConfigurationModel != null &&
                    clientPortal.portalConfigurationModel.languages != null &&
                    clientPortal.portalConfigurationModel.languages.includes(
                      lang
                    )
                  "
                  class="mt-3"
                >
                  <div
                    v-for="(item, key) in currentTranslation[lang]"
                    :key="key"
                  >
                    <div v-if="matchSearchTerm(key, lang)">
                      <v-text-field
                        :disabled="!isGrantedUser()"
                        :append-outer-icon="
                          isCurrentFieldUnsaved(lang, key)
                            ? 'mdi-content-save'
                            : ''
                        "
                        @click:append-outer="saveTranslation(lang, key)"
                        :loading="
                          isCurrentFieldUnsaved(lang, key) ||
                          currentTranslationBase[lang][key] !=
                            currentTranslation[lang][key]
                        "
                        outlined
                        :label="key"
                        v-model="currentTranslation[lang][key]"
                        @keypress="changeTranslation(lang, key)"
                        @input="changeTranslation(lang, key)"
                        persistent-hint
                        hint="Pas de surcharge"
                      >
                        <template v-slot:message>
                          <div
                            v-if="
                              currentTranslationBase[lang][key] !=
                              currentTranslation[lang][key]
                            "
                            class="font-weight-bold subtitle-2"
                          >
                            Valeur par défault :
                            {{ currentTranslationBase[lang][key] }}
                          </div>
                        </template>
                        <template v-slot:progress>
                          <v-progress-linear
                            v-if="isCurrentFieldUnsaved(lang, key)"
                            :value="100"
                            color="orange"
                            absolute
                            height="5"
                          ></v-progress-linear>
                          <v-progress-linear
                            v-else-if="
                              currentTranslationBase[lang][key] !=
                              currentTranslation[lang][key]
                            "
                            :value="100"
                            color="blue"
                            absolute
                            height="5"
                          ></v-progress-linear>
                        </template>
                      </v-text-field>
                      <v-divider class="mb-2"></v-divider>
                    </div>
                  </div>

                  <div v-if="!hasSearchResult">
                    Pas de résultat(s) trouvé pour la recherche.
                  </div>
                </div>
                <confirm-dialog
                  :open.sync="openConfirmDialog"
                  v-on:cancel="closeConfirmDialog"
                  v-on:confirm="
                    removeClientPortalTranslation(clientPortalId, lang)
                  "
                >
                  <template #title> Demande de confirmation </template>
                  <slot name="confirm-text">
                    Êtes-vous sûr.e de vouloir remettre à zéro la surcharge de
                    la traduction pour la langue {{ lang.toUpperCase() }} ?
                  </slot>
                </confirm-dialog>
              </v-tab-item>
            </v-tabs>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <div v-else>
      <p>Pas de traduction possible pour ce modèle de portail.</p>
    </div>
  </div>
</template>
<script>
import { onMounted, toRefs, triggerRef, ref } from "@vue/composition-api";
import { useTranslation } from "@/composables/translation";
import router from "@/router";
import { useClientPortal } from "@/composables/client-portal";
import ConfirmDialog from "@/components/General/ConfirmDialog.vue";
import { useRoles } from "../../composables/roles";

export default {
  components: {
    ConfirmDialog,
  },
  props: {
    languages: Array,
  },
  setup() {
    /* Import des API */
    const {
      updateClientPortalTranslation,
      getClientPortalTranslation,
      translationData,
      removeClientPortalTranslation,
      currentTranslationBase,
      currentTranslation,
      currentTranslationChanged,
      matchSearchTerm,
      changeTranslation,
      isCurrentFieldUnsaved,
    } = useTranslation();
    const { showClientPortal } = useClientPortal();
    const { currentClientPortal: clientPortal } = useClientPortal();
    const { isGrantedUser } = useRoles();

    /* Variables */
    const openConfirmDialog = ref(false);
    const clientId = router.currentRoute.params.id;
    const clientPortalId = router.currentRoute.params.id;
    const baseUrl = config.VUE_APP_API_PUBLIC;
    const loadingReset = ref(false);

    /* Cycle de vie */
    onMounted(async () => {
      translationData.isLoading = true;
      await showClientPortal(clientId);
      if (clientPortal.value.portalConfigurationModel.languages != null) {
        clientPortal.value.portalConfigurationModel.languages.forEach(
          (lang) => {
            getClientPortalTranslation(clientPortalId, lang);
          }
        );
      }
    });

    /* Méthodes */
    const saveTranslation = async (lang, key) => {
      closeConfirmDialog();
      loadingReset.value = true;
      console.log(key);
      currentTranslationChanged.value[lang] = {};

      triggerRef(currentTranslation);
      triggerRef(currentTranslationChanged);

      await updateClientPortalTranslation(
        currentTranslation.value,
        clientPortalId,
        lang
      );
      loadingReset.value = false;
    };
    const closeConfirmDialog = function () {
      openConfirmDialog.value = false;
    };

    return {
      baseUrl,
      matchSearchTerm,
      clientPortal,
      clientPortalId,
      ...toRefs(translationData),
      currentTranslation,
      currentTranslationBase,
      updateClientPortalTranslation,
      removeClientPortalTranslation,
      changeTranslation,
      saveTranslation,
      currentTranslationChanged,
      isCurrentFieldUnsaved,
      openConfirmDialog,
      closeConfirmDialog,
      loadingReset,
      isGrantedUser,
    };
  },
};
</script>
